export const POLICIES_POLICY_VALUE_VIEW = "view";
export const POLICIES_POLICY_VALUE_UPDATE = "update";
export const POLICIES_POLICY_VALUE_DELETE = "delete";
export const POLICIES_POLICY_VALUE_SOFT_DELETE = "soft_delete";
export const POLICIES_POLICY_VALUE_RESTORE = "restore";
export const POLICIES_POLICY_VALUE_ENABLE = "enable";
export const POLICIES_POLICY_VALUE_DISABLE = "disable";
export const POLICIES_POLICY_VALUE_DOWNLOAD = "download";
export const POLICIES_POLICY_VALUE_UPDATE_RECORDS_ACCOUNTS =
  "update_records_accounts";
export const POLICIES_POLICY_VALUE_PASSWORD_RESETS = "password_resets";
export const POLICIES_POLICY_VALUE_ACCESS_TOKENS = "access_tokens";
export const POLICIES_POLICY_VALUE_REVIEW = "review";
export const POLICIES_POLICY_VALUE_REQUEST_REVIEW = "request_review";
export const POLICIES_POLICY_VALUE_QUOTAS = "quotas";
export const POLICIES_POLICY_VALUE_PUBLISH = "publish";
export const POLICIES_POLICY_VALUE_UPDATE_ITEMS = "update_items";
export const POLICIES_POLICY_VALUE_UPDATE_DEFAULTS = "update_defaults";
export const POLICIES_POLICY_VALUE_ASSOCIATE = "associate";
export const POLICIES_POLICY_VALUE_DISSOCIATE = "dissociate";
export const POLICIES_POLICY_VALUE_ACCEPT = "accept";
export const POLICIES_POLICY_VALUE_REFUSE = "refuse";
export const POLICIES_POLICY_VALUE_VALIDATE = "validate";
export const POLICIES_POLICY_VALUE_INVALIDATE = "invalidate";
export const POLICIES_POLICY_VALUE_UPDATE_VALIDATION_ACCEPT =
  "update_validation_accept";
export const POLICIES_POLICY_VALUE_UPDATE_VALIDATION_REFUSE =
  "update_validation_refuse";
export const POLICIES_POLICY_VALUE_UPDATE_PRESENCE_PRESENT =
  "update_presence_present";
export const POLICIES_POLICY_VALUE_UPDATE_PRESENCE_ABSENT =
  "update_presence_absent";
export const POLICIES_POLICY_VALUE_UPDATE_STATE_CANCELLED =
  "update_state_cancelled";
export const POLICIES_POLICY_VALUE_UPDATE_ARRIVAL = "update_arrival";
export const POLICIES_POLICY_VALUE_UPDATE_DEPARTURE = "update_departure";
export const POLICIES_POLICY_VALUE_JUSTIFICATIVE = "justificative";
export const POLICIES_POLICY_VALUE_DOWNLOAD_REGISTRATION_CERTIFICATE =
  "download_registration_certificate";
export const POLICIES_POLICY_VALUE_CANCEL = "cancel";
export const POLICIES_POLICY_VALUE_PAY = "pay";
export const POLICIES_POLICY_VALUE_GENERATE_ADVANCE_INVOICING =
  "generate_advance_invoicing";
